//src/services/adminCommunity.api.js
import { adminApiRequest } from "./adminApi";

export const getCommunityEmails = () => {
  return adminApiRequest("/community");
};
